import Page from "layouts/Page";
import { Divider, Heading, Box } from "@chakra-ui/react";

export default function () {
  return (
    <Page>
      <Box bg="white" p={6} my={6} borderRadius="xl" boxShadow={"xl"}>
        <article>
          <Heading>Charte des données personnelles</Heading>
          <Divider />
          <p>En vigueur au 01/04/2021</p>
          <section>
            <p>
              Chez Tête en l’air, on tient à respecter votre vie privée !<br />
              <br />
              La protection et la confidentialité de vos données à caractère
              personnel, pour nous, c’est primordial ! Vos données à caractère
              personnel seront traitées comme étant strictement confidentielles
              et pour les seuls besoins de nos services à moins que vous n’en
              décidiez autrement.
            </p>
            <p>
              <strong>Notre engagement</strong>
            </p>
            <ul>
              <li>
                Nous sommes respectueux de votre vie privée et de vos choix,
                c’est pour cela que les communications que vous recevez de notre
                part peuvent faire l’objet d’un arrêt à tout moment.
              </li>
              <li>
                Nous sommes respectueux de vos droits en tant qu’Utilisateur,
                c’est pour cela que nous mettons tout en œuvre pour que vous
                puissiez les exercer et ainsi satisfaire au mieux vos demandes.
              </li>
              <li>
                Lorsque que nous devons utiliser des prestataires externes pour
                certaines de nos missions, nous les sélectionnons rigoureusement
                et veillons à ce qu’ils soient également engagés en matière de
                protection des données à caractère personnel.
              </li>
            </ul>
            <p>Cette politique est complétée par :</p>
            <ul>
              <li>
                <a href="/legal">Nos mentions légales</a>
              </li>
              <li>
                <a href="/cookies">Notre politique en matière de cookies</a>
              </li>
              <li>
                <a href="/cgv">Nos CGV</a>
              </li>
            </ul>
          </section>
          <section>
            <Heading fontSize="xl">1 - Quelques définitions :</Heading>
            <p>
              <strong>Donnée(s) à caractère personnel :</strong> Désigne toute
              information se rapportant à une personne physique ou morale
              identifiée ou identifiable ; est réputée être une « personne
              physique ou morale identifiable » une personne physique ou morale
              qui peut être identifiée, directement ou indirectement, notamment
              par référence à un identifiant, tel qu’un nom, un numéro
              d’identification, des données de localisation, un identifiant en
              ligne, ou à un ou plusieurs éléments spécifiques propres à son
              identité physique, physiologique, génétique, psychique,
              économique, culturelle ou sociale ;
            </p>
            <p>
              <strong>Loi Informatique et Liberté :</strong> Désigne la Loi n°
              78-17 du 6 janvier 1978 relative à l’informatique, aux fichiers et
              aux libertés accessibles sur internet à l’adresse suivante :{" "}
              <a
                href="https://www.legifrance.gouv.fr/affichTexte.docidTexte=JORFTEXT000000886460"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.legifrance.gouv.fr/affichTexte.docidTexte=JORFTEXT000000886460
              </a>
            </p>
            <p>
              <strong>Politique :</strong> Désigne la présente politique en
              matière de Protection des Données à caractère personnel ;
            </p>
            <p>
              <strong>Responsable de traitement :</strong> Aux termes de
              l’article 4.7 du RGPD, désigne la personne physique ou morale,
              l’autorité publique, le service ou un autre organisme qui, seul ou
              conjointement avec d’autres, détermine les finalités et les moyens
              du traitement; lorsque les finalités et les moyens de ce
              traitement sont déterminés par le droit de l’Union ou le droit
              d’un État membre, le responsable du traitement peut être désigné
              ou les critères spécifiques applicables à sa désignation peuvent
              être prévus par le droit de l’Union ou par le droit d’un État
              membre ;
            </p>
            <p>
              <strong>RGPD :</strong> Désigne le RÈGLEMENT (UE) 2016/679 DU
              PARLEMENT EUROPÉEN ET DU CONSEIL du 27 avril 2016 accessible en
              ligne à l’adresse suivante :
              <a
                href="https://eur-lex.europa.eu/legal-content/FR/TXT/PDF/?uri=CELEX:32016R0679&from=FR"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://eur-lex.europa.eu/legal-content/FR/TXT/PDF/?uri=CELEX:32016R0679&from=FR
              </a>
              ;
            </p>
            <p>
              <strong>Services :</strong> Ensemble des prestations mises à
              disposition de l’Utilisateur par la Société et accessibles via le
              Site ;
            </p>
            <p>
              <strong>Site :</strong> Le site internet de Tête en l’air
              permettant à l’Utilisateur d’avoir accès aux Services, à savoir :
              www.tete-en-lair.fr
            </p>
            <p>
              <strong>Sous-Traitant :</strong> Désigne, aux termes de l’article
              4.8 du RGPD, la personne physique ou morale, l’autorité publique,
              le service ou un autre organisme qui traite des Données à
              caractère personnel pour le compte du Responsable du Traitement ;
            </p>
            <p>
              <strong>Traitement(s) :</strong> Désigne toute opération ou tout
              ensemble d’opérations effectuées ou non à l’aide de procédés
              automatisés et appliquées à des données ou des ensembles de
              Données à caractère personnel, telles que la collecte,
              l’enregistrement, l’organisation, la structuration, la
              conservation, l’adaptation ou la modification, l’extraction, la
              consultation, l’utilisation, la communication par transmission, la
              diffusion ou toute autre forme de mise à disposition, le
              rapprochement ou l’interconnexion, la limitation, l’effacement ou
              la destruction ;
            </p>
            <p>
              <strong>Utilisateur :</strong> Désigne toute personne physique ou
              morale accédant au Site.
            </p>
          </section>
          <section>
            <Heading fontSize="xl">
              2 - Identité du Responsable de Traitement
            </Heading>
            <p>
              Les Données à caractère personnel sont collectées par Never Stop,
              auto-entreprise gérée par Benjamin Barbe, immatriculée au Registre
              du Commerce et des Sociétés de Poitiers sous le numéro 839 842 069
              et dont le siège social est situé au : 8, Mirbazin 86700 Payré, la
              « Société ». Nous sommes soucieux de la protection des Données à
              caractère personnel qui nous sont confiées. Nous nous engageons à
              assurer le meilleur niveau de protection de vos Données à
              caractère personnel en conformité avec le RGPD ‘Règlement Général
              sur la Protection des Données’ Règlement (UE) 2016/679 du
              Parlement Européen et du Conseil du 27 avril 2016 et la Loi
              Informatique et Libertés loi n° 2018-493 du 20 juin 2018,
              promulguée le 21 juin 2018 qui a modifié la Loi Informatique et
              Libertés du 6 janvier 1978.
              <br />
              <br />
              Pour toute information sur la protection des Données à caractère
              personnel, vous pouvez également consulter le site de la
              Commission Nationale de l’Informatique et des Libertés
              www.cnil.fr.
            </p>
          </section>
          <section>
            <Heading fontSize="xl">3 - Vos droits</Heading>
            <p>
              En application de la Loi Informatique et Liberté Loi 78-17 du 6
              janvier 1978 modifiée et du Règlement Général sur la Protection
              des Données, l’Utilisateur a la faculté d’exercer les droits
              suivants :
            </p>
            <ul>
              <li>
                <strong>Un droit d’accès : </strong>En tant que personne
                concernée, vous pouvez vous informer sur la nature des Données à
                caractère personnel vous concernant, stockées ou traitées, par
                la Société. Un accès à vos Données à caractère personnel vous
                sera fourni.
              </li>
              <li>
                <strong>Un droit de rectification : </strong>Si des Données à
                caractère personnel sont inexactes ou incomplètes, vous pouvez
                demander à ce qu’elles soient modifiées.
              </li>
              <li>
                <strong>Un droit d’opposition : </strong>Vous avez le droit de
                vous opposer, à tout moment, au Traitement de vos Données à
                caractère personnel lorsque la Société traite vos Données à
                caractère personnel pour des motifs qui leur sont d’intérêt
                légitime ou pour des motifs de marketing
              </li>
              <li>
                <strong>
                  Un droit à l’effacement de vos Données à caractère personnel :{" "}
                </strong>
                Vous pouvez demander la suppression de vos Données à caractère
                personnel dans les cas prévus par la loi.
              </li>
              <li>
                <strong>
                  Un droit à la limitation du Traitement de vos Données à
                  caractère personnel :{" "}
                </strong>
                Vous avez le droit de demander la limitation du Traitement de
                vos Données à caractère personnel quand c’est autorisé par les
                lois et règlements applicables.
              </li>
              <li>
                <strong>
                  Un droit à la portabilité de vos Données à caractère personnel
                  :{" "}
                </strong>
                Si vous remplissez les conditions définies par les lois et
                règlements relatifs à la protection des données personnelles,
                vous avez le droit de recevoir un sous-ensemble de vos Données à
                caractère personnel et de les transférer à un autre responsable
                de traitement.
              </li>
              <li>
                <strong>
                  Droit de définir le sort de vos données à caractère personnel
                  :{" "}
                </strong>
                La Société peut être amenée à disposer de Données à caractère
                personnel relatives à une personne décédée. Nous respecterons
                les directives données par toute personne physique relatives à
                la conservation, l’effacement, la communication de ses Données à
                caractère personnel après son décès. En l’absence de telles
                directives, la Société fera droit aux demandes des héritiers
                telles que limitativement énoncées par les dispositions
                applicables de la Loi Informatique et Libertés.
              </li>
            </ul>
            <p>
              Pour exercer vos droits, veuillez par mail à{" "}
              <a className="link" href="mailto:contact@tete-en-lair.fr">
                contact@tete-en-lair.fr
              </a>
              .
            </p>
            <p>
              Si vous estimez que l’un de vos droits n’est pas respecté par la
              Société, vous avez la possibilité d’introduire une action auprès
              de la Cnil via son site internet : www.cnil.fr.
            </p>
          </section>
          <section>
            <Heading fontSize="xl">
              4 - Quelles informations collectons-nous ?
            </Heading>
            <p>
              La communication de vos Données à caractère personnel personnelles
              est dans la plupart des cas délibérée. Du fait de nos obligations,
              nous sommes tenus de vérifier l’exactitude de certaines de vos
              Données à caractère personnel, nous pourrons, dans ce cas, vous
              solliciter.
            </p>
            <section>
              <Heading fontSize="md">
                4.1 Comment collectons-nous vos Données à caractère personnel ?
              </Heading>
              <p>
                Pour délivrer son Service, la Société collecte des Données à
                caractère personnel sur l’Utilisateur. La collecte de vos
                Données à caractère personnel peut s’effectuer :
              </p>
              <ul>
                <li>Depuis le Site ;</li>
                <li>Via l’espace spotter (pour les photographes) ;</li>
                <li>Par l’utilisation des Services ;</li>
                <li>Par le paiement d’un Service ;</li>
                <li>
                  Lors d’une demande de renseignement, d’un échange téléphonique
                  ou d’une prise de contact ;
                </li>
              </ul>
              <p>
                Sur les formulaires de collecte de Données à caractère personnel
                sur le Site, l’Utilisateur est informé du caractère obligatoire
                ou non de la collecte de ses Données à caractère personnel. En
                cas de non-fourniture d’un champ de données obligatoire, nous ne
                pourrons malheureusement pas accomplir le Service et respecter
                nos engagements.
              </p>
            </section>
            <section>
              <Heading fontSize="md">
                4.2 Les Données à caractère personnel collectées concernant les
                personnes physiques
              </Heading>
              <p>
                Selon le Service sélectionné, nous sommes susceptibles de
                collecter les informations suivantes : Nom(s), prénom(s),
                adresse électronique, date de naissance, Numéro de vol, date du
                vol.
              </p>
            </section>
          </section>
          <section>
            <Heading fontSize="xl">
              5 - Les finalités pour lesquelles nous collectons les Données à
              caractère personnel
            </Heading>
            <p>
              Nous traitons vos Données à caractère personnel afin de vous
              apporter la réponse la plus adaptée à vos besoins. Dans le cadre
              de l’utilisation des Services, nous sommes amenés à traiter vos
              Données à caractère personnel pour :
            </p>
            <ul>
              <li>La gestion de la relation commerciale ;</li>
              <li>La gestion, la facturation et le suivi des dossiers ;</li>
              <li>La gestion de l’espace spotters ;</li>
              <li>La gestion des impayés et des contentieux ;</li>
              <li>Le recueil des commentaires sur le Site ;</li>
              <li>Le recueil des avis des Utilisateurs ;</li>
              <li>La réponse aux éventuelles questions et réclamations ;</li>
              <li>L’élaboration de statistiques non commerciales ;</li>
              <li>Le suivi et statistiques d’utilisation de notre Site ;</li>
            </ul>
            <p>
              Conformément à la réglementation en vigueur en matière de
              protection des Données à caractère personnel, la Société a défini
              une base légale pour chacun des Traitements de Données à caractère
              personnel qu’elle met en œuvre comme suit :
            </p>
            <ul>
              <li>
                L’exécution de mesures précontractuelles ou d’un contrat ;
              </li>
              <li>L’exécution d’une obligation légale ;</li>
              <li>
                Lorsque cela est dans l’intérêt légitime du Responsable de
                Traitement ;
              </li>
              <li>Lorsque l’Utilisateur a donné son consentement ;</li>
            </ul>
          </section>
          <section>
            <Heading fontSize="xl">
              6. La durée de conservation des Données à caractère personnel
            </Heading>
            <p>
              Selon le cas de figure, la Société a défini des durées de
              conservation distinctes. Nous faisons en sorte que les durées de
              conservation soient pertinentes et respectent les délais légaux.
              <br />
              <br />
              Pour établir la durée de conservation des Données à caractère
              personnel, la Société applique les critères suivants :
            </p>
            <ul>
              <li>
                Les Données à caractère personnel de prospect : sont conservées
                trente-six (36) mois. Le point de départ de la durée de
                conservation est le dernier échange que vous avez eu avec l’un
                de nos services
              </li>
              <li>
                Les Données à caractère personnel du client : sont conservées
                pour la durée de la relation contractuelle et puis soixante (60)
                mois au terme de cette dernière.
              </li>
              <li>
                Les Données à caractère personnel des candidats : vingt-quatre
                (24) mois si le candidat a consenti à la conservation de sa
                candidature. Vous pouvez, à tout moment, demander la suppression
                de vos informations.
              </li>
            </ul>
            <p>
              La Société est susceptible de conserver certaines données au-delà
              des délais annoncés ci-dessus afin de remplir ses obligations
              légales ou réglementaires.
              <br />
              <br />
              L’Utilisateur est informé que la Société est susceptible de
              conserver des Données à caractère personnel afin de réaliser des
              statistiques concernant ses Utilisateurs. Dans ce cas, les données
              seront anonymisées et ne pourront faire l’objet d’aucune
              reconstitution.
            </p>
          </section>
          <section>
            <Heading fontSize="xl">
              7. Lutte contre le blanchiment de capitaux et le financement du
              terrorisme
            </Heading>
            <p>
              Pour répondre à ses obligations légales, la Société met un œuvre
              des dispositifs de surveillance destinés à la lutte contre le
              blanchiment de capitaux, le financement du terrorisme et permettre
              l’application de sanctions.
              <br />
              <br />
              TRACFIN, l’autorité de contrôle ainsi que l’autorité de sanctions
              peuvent être destinataires d’informations, y compris les Données à
              caractère personnel, à cette fin.
              <br />
              <br />
              Les Données à caractère personnel traitées pour la lutte contre le
              blanchissement d’argent et la lutte contre le terrorisme ainsi que
              toutes les données relatives aux opérations réalisées par les
              personnes sont conservées cinq (5) ans à compter de clôture de la
              fin de la relation avec vous.
              <br />
              <br />
              Conformément au Code monétaire et financier, le droit d’accès à
              ces Données à caractère personnel s’exerce auprès de la Commission
              Nationale de l’Informatique et Libertés (voir www.cnil.fr).
            </p>
          </section>
          <section>
            <Heading fontSize="xl">8 - Lutte contre la fraude</Heading>
            <p>
              Afin de limiter toute prise en charge non justifiée et lutter
              contre la fraude, l’Utilisateur est informé que certaines de ses
              Données à caractère personnel peuvent être utilisées dans ce
              cadre. En outre, les Utilisateurs sont informés du fait que la
              Société met en œuvre un dispositif ayant pour finalité la lutte
              contre la fraude pouvant, notamment, conduire à l’inscription sur
              une liste de personnes présentant un risque de fraude.
              <br />
              <br />
              Les données traitées pour la lutte contre la fraude sont
              conservées cinq (5) ans maximums à compter de la clôture du
              dossier de fraude. En cas de procédure judiciaire, les données
              seront conservées jusqu’à la fin de la procédure et expiration des
              prescriptions applicables.
              <br />
              <br />
              Les personnes inscrites sur une liste de fraudeurs présumés seront
              désinscrites passé le délai de cinq (5) ans à compter
              l’inscription sur cette liste.
              <br />
              <br />
              Conformément au Code monétaire et financier, le droit d’accès à
              ces données s’exerce auprès de la Commission Nationale de
              l’Informatique et Libertés (voir cnil.fr).
            </p>
          </section>
          <section>
            <Heading fontSize="xl">
              9 - Règles applicables aux paiements par carte bancaire et à la
              protection des données bancaires
            </Heading>
            <p>
              Afin d’assurer la sécurité de vos paiements, la Société utilise
              les services de Paypal et Stripe. Ils garantissent un traitement
              sécurisé de toutes les données sensibles telles que les données
              bancaires et l’identité des Utilisateurs, en conformité avec les
              directives et normes : DSP2, RGPD et PCI-DSS.
              <br />
              <br />
              Les conditions générales des quatre prestataires sont disponibles
              ici :
            </p>
            <ul>
              <li>
                PayPal :{" "}
                <a
                  href="https://www.paypal.com/fr/webapps/mpp/home"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.paypal.com/fr/webapps/mpp/home
                </a>
              </li>
              <li>
                Stripe :{" "}
                <a
                  href="https://stripe.com/fr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://stripe.com/fr
                </a>
              </li>
            </ul>
            <p>
              Lorsque le paiement de votre commande s’effectue par carte
              bancaire, notre système de prise de commande se connecte en temps
              réel avec le système du prestataire qui collecte vos données et
              procède aux diverses vérifications pour éviter les abus et les
              fraudes. Les données sont stockées sur les serveurs de nos
              prestataires et ne sont à aucun moment transmises sur nos
              serveurs. Nos prestataires effectuent les demandes d’autorisation
              auprès de la banque et nous transmettent uniquement le numéro de
              transaction.
              <br />
              <br />
              Afin de vous éviter de saisir à nouveau vos coordonnées bancaires
              lors de prochaines commandes, vous pouvez choisir, en cochant la
              case d’acceptation prévue à cet effet, que vos cartes bancaires
              soient associées à votre compte en ligne. Elles sont enregistrées
              chez nos prestataires de façon sécurisée.
              <br />
              <br />
              Afin de pouvoir débiter le compte lors de la facturation ou de la
              créditer suite à un remboursement, nos prestataires conservent les
              données bancaires associées au n° d’autorisation, le temps
              nécessaire à la réalisation de la transaction et au traitement des
              éventuelles réclamations.
            </p>
          </section>
          <section>
            <Heading fontSize="xl">
              10 - A qui vos Données à caractère personnel sont-elles transmises
              ?
            </Heading>
            <p>
              Afin de vous faire bénéficier du meilleur de notre expertise, vos
              Données à caractère personnel peuvent être communiquées à :
            </p>
            <ul>
              <li>
                Nos services internes : communication, service client, service
                qualité, traitement des demandes
              </li>
            </ul>
            <p>
              Lorsque nous faisons appel à de la sous-traitance, nous faisons en
              sorte que les relations contractuelles fassent l’objet d’un
              encadrement strict au sens de l’article 28 du RGPD. Dans le cadre
              de nos prestations de Services, nous pouvons faire appel à des
              Sous-Traitants pour les opérations suivantes :
            </p>
            <ul>
              <li>La gestion des paiements en ligne ;</li>
              <li>Le recouvrement des impayés ;</li>
              <li>La personnalisation des contenus du Site ;</li>
              <li>
                La réalisation d’opération de maintenance et de développement
                technique du Site ;
              </li>
              <li>Le recueil des avis clients ;</li>
              <li>L’acquisition de nouveaux clients</li>
            </ul>
            <p>
              Dans le cas où nous aurions à défendre nos droits en justice, vos
              Données à caractère personnel pourraient être transmises aux
              autorités et à notre défense.
            </p>
          </section>
          <section>
            <Heading fontSize="xl">
              11 - Les mesures de sécurité que nous mettons en place pour
              protéger vos Données à caractère personnel
            </Heading>
            <p>
              En tant que Responsable de Traitement, la Société prend toutes les
              précautions utiles pour préserver la sécurité et la
              confidentialité de vos Données à caractère personnel. Nous avons
              mis en place un grand nombre de mesures techniques et
              organisationnelles afin de limiter l’accès à vos Données à
              caractère personnel, cela inclut la sécurité physique des
              bâtiments abritant nos systèmes et la sécurité du système
              informatique pour empêcher l’accès externe à vos Données à
              caractère personnel. L’accès à vos Données à caractère personnel
              est limité aux seules personnes ayant la nécessité d’en prendre
              connaissance.
            </p>
          </section>
          <section>
            <Heading fontSize="xl">
              12 - Transfert de vos Données à caractère personnel
            </Heading>
            <p>
              La Société s’efforce de conserver vos Données à caractère
              personnel au sein de l’Union européenne. Toutefois, de manière
              marginale et pour certains Services spécifiques, les Données à
              caractère personnel recueillies par la Société pourraient être
              transmises à des Sous-Traitants établis en dehors de l’Union
              Européenne. Dans ce cas, la Société veillera à ce que des mesures
              adéquates soient mises en place pour garantir la sécurité de vos
              Données à caractère personnel et le respect de vos droits
              conformément à la Loi Informatique et Liberté et au Règlement
              Général sur la Protection des données.
            </p>
          </section>
          <section>
            <Heading fontSize="xl">
              13 - Sites Web tiers & réseaux sociaux
            </Heading>
            <p>
              Nous attirons votre attention sur les réseaux sociaux dont les
              liens paraissent en bas du Site et avec lesquels vous pouvez être
              amenés à interagir pour nous soutenir et/ou partager l’une de nos
              publications. Lors de votre interaction, la Société ne peut être
              tenue comme responsable en cas de problème. Sachez que lorsque
              vous utilisez ces liens, des informations à votre sujet peuvent
              être collectées ou partagées. Nous vous encourageons à consulter
              les politiques et paramètres de confidentialité des réseaux
              sociaux avec lesquels vous interagissez, afin de connaître les
              informations susceptibles d’être recueillies, utilisées ou
              partagées par ces sites.
            </p>
            <ul>
              <li>
                <strong>Instagram</strong> :{" "}
                <a
                  href="https://www.facebook.com/help/instagram/1896641480634370"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.facebook.com/help/instagram/1896641480634370
                </a>
              </li>
            </ul>
          </section>
          <section>
            <Heading fontSize="xl">14 - Politique cookies</Heading>
            <p>
              La politique de cookies est disponible sur le lien suivant :
              https://www.legalplace.fr/cookies/
            </p>
          </section>
          <section>
            <Heading fontSize="xl">15 - Modification de la Politique</Heading>
            <p>
              La Société peut modifier la Politique à tout moment. Les
              modifications éventuelles ne peuvent avoir aucune incidence sur
              les achats de Service effectués sur le Site antérieurement à leur
              publication, lesquels Services restent soumis à la Politique telle
              qu’acceptée par l’Utilisateur lors de la validation de l’achat.
              L’Utilisateur est invité à prendre connaissance de la Politique, à
              chaque fois, qu’il utilise les Services du Site, sans qu’il soit
              nécessaire de l’en prévenir formellement.
            </p>
          </section>
          <section>
            <Heading fontSize="xl">
              16 - Droit applicable et tribunaux compétents
            </Heading>
            <p>
              La Politique est soumise au droit français. En cas de litige et
              dans le cas où un accord amiable ne pourrait intervenir, les
              tribunaux compétents seront ceux du ressort de la Cour d’appel de
              Paris, nonobstant pluralité de défendeurs ou appel en garantie.
            </p>
          </section>
        </article>
      </Box>
    </Page>
  );
}
